import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=093e7d6f"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=093e7d6f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093e7d6f')) {
      api.createRecord('093e7d6f', component.options)
    } else {
      api.reload('093e7d6f', component.options)
    }
    module.hot.accept("./TermsOfService.vue?vue&type=template&id=093e7d6f", function () {
      api.rerender('093e7d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/termsOfService/TermsOfService.vue"
export default component.exports